import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const WhyWeFeedRawRoot = styled('div', {
  backgroundColor: '$secondary-100',
  width: '100%',
  paddingTop: '$10',
  '@bp2': {
    marginTop: '$10',
    paddingTop: '0',
  },
})

export const Claim = styled('div', {
  margin: 'auto',
  width: '100%',
  padding: '$5 0',
  backgroundColor: '$secondary-500',
  borderTop: 0,
  borderBottom: '12px solid transparent',
  borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

  '@bp2': {
    borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
  },

  '&': {
    [`${Text}`]: {
      width: '100%',
    },
  },
})
